import React from "react";
import "./StepPoints.scss";

const StepPoints = ({
    currentStep,
    setCurrentStep,
    totalSteps
}) => {
    return (
        <div className="steps-points">
            {Array.from({ length: totalSteps }).map((_, index) => {
                const stepNumber = index + 1;
                const isActive = stepNumber <= currentStep;
                const isLast = stepNumber === totalSteps;

                return (
                    <React.Fragment key={stepNumber}>
                        <div className={`steps-points-circle ${isActive ? "active" : ""}`}
                            onClick={(e) => {
                                if (isActive) {
                                    setCurrentStep(stepNumber)
                                }
                            }}
                        >
                            {stepNumber}
                        </div>
                        {!isLast && <div className={`steps-points-line ${isActive ? "active" : ""}`} />}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export { StepPoints }